export default __webpack_public_path__ + "static/media/pix.46058348.png";